module.exports = __webpack_public_path__ + "img/info3-bg.8a8ad160.svg";